import {reject, submitProposalDecisionExpiration} from '../../rest/candidature';
import {useParams} from 'react-router-dom';
import {CandidatureExpiration} from "../../components/candidature/CandidatureExpiration";

export function EmitExpirationDecision() {
    const {externalId} = useParams();

    const submit = async () => {
        await submitProposalDecisionExpiration(externalId);
        sessionStorage.setItem('proposalDecisionExpiration','true');
    }

    return (
        <CandidatureExpiration
            validationTitle='candidatureExpiration.title.reject'
            messageConfirmation='candidatureExpiration.message.reject'
            callbackHandler={submit}
            isApprove={false}
        />
    );

}
